// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Rn-z","tupacHeader":"Sn-z","tupacHeader2":"Tn-z","tupacMenu":"Un-z","tupacMenu2":"Vn-z","tupacMain":"Wn-z","tupacMain2":"Xn-z"};